// This program has been developed by students from the bachelor Computer Science at
// Utrecht University within the Software Project course.
// Copyright (c) Utrecht University (Department of Information and Computing Sciences)

import { createApp } from "vue";
import App from "@/App.vue";
import router from "@/router";
import { store, key } from "@/store";
import "./index.css";
import i18n from "./i18n";

const app = createApp(App).use(i18n).use(store, key).use(router).mount("#app");
